import { render, staticRenderFns } from "./ContactSetting.vue?vue&type=template&id=a183defa&scoped=true&"
import script from "./ContactSetting.vue?vue&type=script&lang=js&"
export * from "./ContactSetting.vue?vue&type=script&lang=js&"
import style0 from "./ContactSetting.vue?vue&type=style&index=0&id=a183defa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a183defa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VContainer,VIcon,VSimpleTable,VTooltip})
